import { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [toast, setToast] = useState({
    open: false,
    title: '',
    message: '',
    actions: [],
    severity: 'info',
    position: 'top-center', // 'top-left'|'top-right'|'bottom-left'|'bottom-right'
    duration: 5000,
  });

  const showNotification = useCallback((options) => {
    setToast({
      open: true,
      title: options.title || 'Notification',
      message: options.message || '',
      actions: options.actions || [],
      severity: options.severity || 'info',
      position: options.position || 'top-center',
      duration: options.duration || 5000,
    });
  }, []);

  const closeNotification = useCallback(() => {
    setToast((t) => ({ ...t, open: false }));
  }, []);

  return (
    <NotificationContext.Provider value={{ toast, showNotification, closeNotification }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  return useContext(NotificationContext);
}
